import axios from "axios";

const base = () => import.meta.env.VITE_API_BASE_URL;
const authHeaders = () => ({
  Authorization: "Bearer " + localStorage.getItem("token"),
});

export const getOlympicList = (active = true) =>
  axios.get(`${base()}/api/olympic/${active ? "list" : "listInactive"}`, {
    headers: authHeaders(),
  });

export const getEnrolledOlympics = () =>
  axios.get(`${base()}/api/olympic/enrolled`, { headers: authHeaders() });

export const getOlympicById = (id) =>
  axios.get(`${base()}/api/olympic/${id}`, { headers: authHeaders() });

export const getOlympicBySlug = (slug) =>
  axios.get(`${base()}/api/olympic/by-slug/${slug}`, { headers: authHeaders() });

export const saveOlympic = (payload) =>
  axios.post(`${base()}/api/olympic/save`, payload, { headers: authHeaders() });

export const editOlympic = (id, payload) =>
  axios.put(`${base()}/api/olympic/edit/${id}`, payload, { headers: authHeaders() });

export const enableOlympic = (id) =>
  axios.post(`${base()}/api/olympic/enable/${id}`, {}, { headers: authHeaders() });

export const disableOlympic = (id) =>
  axios.post(`${base()}/api/olympic/disable/${id}`, {}, { headers: authHeaders() });

export const changeOlympicShadowMode = (id) =>
  axios.put(`${base()}/api/olympic/changeshadowmode/${id}`, {}, { headers: authHeaders() });

export const createPhase = (olympicId, payload) =>
  axios.post(`${base()}/api/olympic/${olympicId}/phases`, payload, {
    headers: authHeaders(),
  });

export const updatePhase = (olympicId, phaseId, payload) =>
  axios.put(`${base()}/api/olympic/${olympicId}/phases/${phaseId}`, payload, {
    headers: authHeaders(),
  });

export const deletePhase = (olympicId, phaseId) =>
  axios.delete(`${base()}/api/olympic/${olympicId}/phases/${phaseId}`, {
    headers: authHeaders(),
  });

export const linkPhaseExam = (olympicId, phaseId, payload) =>
  axios.post(`${base()}/api/olympic/${olympicId}/phases/${phaseId}/exams`, payload, {
    headers: authHeaders(),
  });

export const unlinkPhaseExam = (olympicId, phaseId, examId) =>
  axios.delete(`${base()}/api/olympic/${olympicId}/phases/${phaseId}/exams/${examId}`, {
    headers: authHeaders(),
  });

export const linkPhaseSimulacrum = (olympicId, phaseId, simulacrumId) =>
  axios.post(
    `${base()}/api/olympic/${olympicId}/phases/${phaseId}/simulacrums`,
    { simulacrumId },
    { headers: authHeaders() }
  );

export const unlinkPhaseSimulacrum = (olympicId, phaseId, simulacrumId) =>
  axios.delete(
    `${base()}/api/olympic/${olympicId}/phases/${phaseId}/simulacrums/${simulacrumId}`,
    { headers: authHeaders() }
  );

export const releasePhaseRanking = (olympicId, phaseId) =>
  axios.put(`${base()}/api/olympic/${olympicId}/phases/${phaseId}/ranking/release`, null, {
    headers: authHeaders(),
  });

export const getPhaseRanking = (olympicId, phaseId) =>
  axios.get(`${base()}/api/olympic/${olympicId}/phases/${phaseId}/ranking`, {
    headers: authHeaders(),
    timeout: 90000,
  });

export const getStudentState = (olympicId) =>
  axios.get(`${base()}/api/olympic/${olympicId}/student-state`, {
    headers: authHeaders(),
  });
